'use client';

import { c as _c } from "react/compiler-runtime";
import { useDotEnv } from '@repo/sdk/dot-env';
import { cn } from '@repo/ui/lib';
import 'react-phone-input-2/lib/style.css';
import { useEffect, useState } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
export const PhoneInput = props => {
  const $ = _c(13);
  const env = useDotEnv();
  let t0;
  if ($[0] !== env.SOURCE) {
    t0 = () => env.SOURCE === "kcharles" ? "gb" : "";
    $[0] = env.SOURCE;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [country, setCountry] = useState(t0);
  let t1;
  if ($[2] !== env.SOURCE || $[3] !== props.value) {
    t1 = () => {
      if (!props.value && env.SOURCE === "kcharles") {
        setCountry("gb");
      }
    };
    $[2] = env.SOURCE;
    $[3] = props.value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props.value) {
    t2 = [props.value];
    $[5] = props.value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("!border-input  dark:!border-transparent !bg-input/30", " !border-r-transparent dark:!border-r-transparent", "[&>.selected-flag:hover]:!bg-accent [&>.selected-flag:active]:!bg-accent [&>.selected-flag:focus]:!bg-accent [&>.selected-flag.open]:!bg-accent");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("text-neutral-900! !border-input hover:!border-input !bg-background dark:text-neutral-300!", "[&>li:hover]:!bg-accent [&>li:hover]:!text-accent-foreground", "[&>li:active]:!bg-accent [&>li:active]:!text-accent-foreground", "[&>li:focus]:!bg-accent [&>li:focus]:!text-accent-foreground", "[&>li.highlight]:!bg-accent [&>li.highlight]:!text-accent-foreground");
    t5 = cn("w-full! py-2 h-10! !border-input !rounded-r-lg  shadow-none dark:!bg-input/30 dark:text-neutral-300", "peer");
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== country || $[11] !== props) {
    t6 = <ReactPhoneInput buttonClass={t3} containerClass="!rounded-input" country={country} dropdownClass={t4} inputClass={t5} placeholder="Phone number" {...props} />;
    $[10] = country;
    $[11] = props;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};